import { useState } from 'react';

export const useDraftState = () => {
  const [view, setView] = useState('initial');
  const [config, setConfig] = useState({
    teamCount: 12,
    positions: {
      QB: 2,
      RB: 3,
      WR: 5,
      TE: 1,
      FLEX: 0,
      SFLEX: 0,
      DEF: 1,
      K: 2,
      BENCH: 0
    },
    teamNames: []
  });
  const [draftedPlayers, setDraftedPlayers] = useState({});
  const [selectedPlayers, setSelectedPlayers] = useState(new Set());
  const [draftHistory, setDraftHistory] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [currentDraftName, setCurrentDraftName] = useState(null);
  const [draftName, setDraftName] = useState(() => {
    const today = new Date();
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return `${months[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`;
  });
  const [savedDrafts, setSavedDrafts] = useState([]);
  const [loadDraftView, setLoadDraftView] = useState(false);
  const [editingTeamName, setEditingTeamName] = useState(null);
  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [isLoadingDrafts, setIsLoadingDrafts] = useState(false);
  const [isLoadingDraft, setIsLoadingDraft] = useState(false);
  const [currentLoadingDraft, setCurrentLoadingDraft] = useState(null);

  const resetDraftState = () => {
    setView('initial');
    setConfig({
      teamCount: 12,
      positions: {
        QB: 2,
        RB: 3,
        WR: 5,
        TE: 1,
        FLEX: 0,
        SFLEX: 0,
        DEF: 1,
        K: 2,
        BENCH: 0
      },
      teamNames: []
    });
    setDraftedPlayers({});
    setSelectedPlayers(new Set());
    setDraftHistory([]);
    setRedoStack([]);
    setCurrentDraftName(null);

    const today = new Date();
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    setDraftName(`${months[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`);
  };

  return {
    view,
    setView,
    config,
    setConfig,
    draftedPlayers,
    setDraftedPlayers,
    selectedPlayers,
    setSelectedPlayers,
    draftHistory,
    setDraftHistory,
    redoStack,
    setRedoStack,
    currentDraftName,
    setCurrentDraftName,
    draftName,
    setDraftName,
    savedDrafts,
    setSavedDrafts,
    loadDraftView,
    setLoadDraftView,
    editingTeamName,
    setEditingTeamName,
    isAutoSaving,
    setIsAutoSaving,
    isLoadingDrafts,
    setIsLoadingDrafts,
    isLoadingDraft,
    setIsLoadingDraft,
    currentLoadingDraft,
    setCurrentLoadingDraft,
    resetDraftState
  };
};
